import type { AssistantTaskListItem } from './assistantTaskLaneState';

type SpreadsheetSessionState = {
  sourceTaskId?: string | null;
  sourceUpdatedAt?: number | null;
} | null | undefined;

const SPREADSHEET_TASK_WORKFLOWS = new Set([
  'artifact.spreadsheet.generate',
  'artifact.spreadsheet.modify',
]);

export const resolveVisibleActiveSpreadsheetTask = (
  activeTaskItems: AssistantTaskListItem[],
  currentSpreadsheetSession: SpreadsheetSessionState,
): AssistantTaskListItem | null => {
  const candidate = activeTaskItems.find((task) => task.workflowKey != null && SPREADSHEET_TASK_WORKFLOWS.has(task.workflowKey)) ?? null;
  if (!candidate) {
    return null;
  }
  if (currentSpreadsheetSession?.sourceTaskId && currentSpreadsheetSession.sourceTaskId === candidate.id) {
    return null;
  }
  if (
    currentSpreadsheetSession?.sourceUpdatedAt
    && candidate.updatedAt
    && candidate.updatedAt <= currentSpreadsheetSession.sourceUpdatedAt
  ) {
    return null;
  }
  return candidate;
};
